import { moveItemInArray } from "@angular/cdk/drag-drop";
import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, NavigationStart, Router } from "@angular/router";
import { ModalDismissReasons, NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";

import { AuthService } from "src/app/_app-core/services/auth/auth.service";
import { DirtyCheckComponent } from "src/app/_models/dirty-check.component";
import { DateUtilsService } from "src/app/_services/dateUtils";
import { InvoiceService } from "./../../../_services/invoice.service";

@Component({
  selector: "app-upload-preview-nonpo",
  templateUrl: "./upload-preview-nonpo.component.html",
  styleUrls: ["./upload-preview-nonpo.component.scss"],
})
export class UploadPreviewNonpoComponent implements OnInit, DirtyCheckComponent {
  docs = [
    {
      docType: "NO1X",
      description: "NO1X",
    },
    {
      docType: "NO1G",
      description: "NO1G",
    },
  ];

  invoiceDetails: any;
  closeResult: string = "";
  modalOptions: NgbModalOptions;
  loading: boolean = false;
  uploadSuccessful: boolean = false;
  saving: boolean = false;
  uploadInvoice: boolean = false;
  displayName: any;
  hasError: boolean = false;
  imgUrl: string = "";
  typeError: boolean = false;
  sizeError: boolean = false;
  fileTypeError: boolean = false;
  fileSizeError: boolean = false;
  invoiceSaved: boolean = false;
  savingError: boolean = false;
  validationError: boolean = false;
  serverError: boolean = false;
  supportingDocuments: any[] = [];
  agreed = [{ status: false }];
  masterData: any;
  responseData: any;
  isError = false;
  vendorData: any;
  pdfSrc: any;
  invoiceFile: any;
  invoiceDataToSave: any;
  isInvoiceChange: boolean = false;
  isUpdatedData: boolean = false;
  invoiceChanged: boolean = false;
  isCondensed: boolean = false;
  currentLayout = {
    isCondensed: true,
  };
  barcodeNo: any;
  eLoaderMsg = "";
  formSubmitted = false;
  previousUrl: any;
  companies: any;
  organisations: any;
  configResCompanies: any;
  configResOrg: any;
  totalSizeError = false;
  files: File[];
  supportingDocsAdded = false;
  canSubmitForm = false;
  allDeleted = false;

  extractedInvoiceNonPo = new FormGroup({
    invoiceType: new FormControl("e-invoice"),
    file: new FormControl(null),

    //reuploadFile: new FormControl(null),
    supportingFiles: new FormControl([]),
    fileSource: new FormControl(""),
    documentSource: new FormControl(""),
    terms_agreed: new FormControl(false),
    emailAddress: new FormControl(null, [Validators.required, Validators.email, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]),
    username: new FormControl(""),
    userID: new FormControl(""),
    companyCode: new FormControl(null, [Validators.required]),
    purchaseOrg: new FormControl(null, [Validators.required]),
    docType: new FormControl(null, [Validators.required]),
  });
  error: any;

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private invoiceService: InvoiceService,
    private authService: AuthService,
    private dateUtils: DateUtilsService
  ) {
    this.modalOptions = {
      backdrop: "static",
      backdropClass: "customBackdrop",
      scrollable: true,
    };

    this.router.events.subscribe((val) => {
      if (val instanceof NavigationStart) {
        this.previousUrl = val.url;
      }
    });

    // this.route.queryParams.subscribe((params) => {
    //     this.previousUrl = params['returnUrl'];

    // });
  }

  canDeactivate() {
    if (!this.formSubmitted) {
      this.loading = true;
      return false;
    } else {
      return true;
    }
  }

  exitForm() {
    this.loading = false;
    this.formSubmitted = true;
    this.previousUrl = this.route.snapshot.queryParams["returnUrl"] || "dashboard";
    this.router.navigateByUrl(this.previousUrl);
  }

  cancelExit() {
    this.loading = false;
  }

  toggleSidebar() {
    this.currentLayout.isCondensed = !this.currentLayout.isCondensed;
    document.body.setAttribute("data-sidebar-size", this.currentLayout.isCondensed ? "condensed" : "default");
  }

  selectDocuments(event: any) {
    const MAX_FILE_SIZE = 25 * 1024 * 1024; // 5MB
    const MAX_TOTAL_SIZE = 100 * 1024 * 1024; // 25MB
    const ALLOWED_TYPES = ["application/pdf"];

    this.files = Array.from(event);
      const totalSize = this.files.reduce((sum, file) => sum + file.size, 0);

    if (totalSize > MAX_TOTAL_SIZE) {
      this.totalSizeError = true;
      this.sizeError = false;
      this.typeError = false;
    }

    for (const file of this.files) {
      if (file.size > MAX_FILE_SIZE) {
        this.sizeError = true;
        this.typeError = false;
        this.totalSizeError = false;
        continue;
      }

      // Filter out any files that are not Word, Excel, or PDF
      if (!ALLOWED_TYPES.includes(file.type)) {
        this.typeError = true;
        this.sizeError = false;
        this.totalSizeError = false;
        continue;
      }
      this.supportingDocuments.push(file);
    }

    if (this.allDeleted === true) {
      if (this.extractedInvoiceNonPo.get("terms_agreed").value === true) {
        this.extractedInvoiceNonPo.patchValue({
          terms_agreed: false,
        });
      }
    } else {
      this.extractedInvoiceNonPo.patchValue({ terms_agreed: false });
    }

    this.supportingDocsAdded = true;
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    this.supportingDocuments.splice(index, 1);

    if (this.supportingDocuments.length === 0) {
      if (this.extractedInvoiceNonPo.get("terms_agreed").value === true) {
        this.extractedInvoiceNonPo.patchValue({
          terms_agreed: false,
        });
      }

      this.canSubmitForm = false;
      this.allDeleted = true;
      this.supportingDocsAdded = false;
    }
  }

  checkSupportingDocuments() {
    if (this.supportingDocuments.length > 0 && this.extractedInvoiceNonPo.get("terms_agreed").value === false) {
      this.canSubmitForm = true;
    } else {
      this.canSubmitForm = false;
    }
  }

  reUploadInvoice(event: any) {
    if (event.length > 0) {
      const fileUploaded = event[0];

      if (fileUploaded.type !== "application/pdf") {
        this.hasError = false;
        this.fileSizeError = false;
        this.fileTypeError = true;
      } else if (fileUploaded.size > 100 * 1024 * 1024) {
        this.fileTypeError = false;
        this.hasError = false;
        this.fileSizeError = true;
      } else {
        this.fileSizeError = false;
        this.fileTypeError = false;

        if (typeof FileReader !== "undefined") {
          let reader = new FileReader();
          reader.onload = (e: any) => {
            this.pdfSrc = e.target.result;
          };
          let $file: any = fileUploaded;
          reader.readAsArrayBuffer($file);
        }

        this.extractedInvoiceNonPo.patchValue({
          fileSource: fileUploaded,
        });

        this.hasError = false;
        this.isInvoiceChange = true;

        // Create ledger array similar to e-invoice submission for non-PO
        const ledger: any[] = [
          {
            docType: this.extractedInvoiceNonPo.value.docType || "",
            docDetail: {
              docFormat: "e-invoice",
              docCat: "non_po_based",
            },
            cmpCode: this.extractedInvoiceNonPo.value.companyCode || "",
            purchaseOrg: this.extractedInvoiceNonPo.value.purchaseOrg || "",
            erpDocType: this.extractedInvoiceNonPo.value.docType || "",
          },
        ];

        this.loading = true;
        this.invoiceChanged = true;
        this.formSubmitted = true;

        const formData: any = new FormData();
        formData.append("sellerCode", localStorage.getItem("sellerCode"));
        formData.append("supplierCode", localStorage.getItem("vendorCode"));
        formData.append("ledger", JSON.stringify(ledger));
        formData.append("invoiceFile", this.extractedInvoiceNonPo.value.fileSource);
        formData.append("extractionVersion", "1");

        this.eLoaderMsg = "Verifying QR Code";

        setTimeout(() => {
          this.eLoaderMsg = "Authenticating QR Code";
        }, 5000);
        setTimeout(() => {
          this.eLoaderMsg = "Extracting Data";
        }, 10000);
        setTimeout(() => {
          this.eLoaderMsg = "Validating Data";
        }, 15000);

        this.invoiceService.extractInvoice(formData).subscribe(
          (res) => {
            this.loading = false;
            this.invoiceChanged = false;
            this.isUpdatedData = true;
            this.responseData = res;
            this.formSubmitted = false;
            if (this.responseData.length !== 0 && this.responseData.status === "error") {
              console.error(this.responseData.message);
            } else {
              this.invoiceDetails = this.responseData;
            }
          },
          (error) => {
            console.error(error);
          }
        );
      }
    }
  }

  onDrop(event: any) {
    moveItemInArray(this.supportingDocuments, event.previousIndex, event.currentIndex);
    this.supportingDocsAdded = true;
  }

  open(content: any) {
    this.modalService.open(content, this.modalOptions).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  onSubmit() {
    this.loading = true;
    this.uploadInvoice = true;
    this.formSubmitted = true;
    this.hasError = false;

    let username = this.invoiceService.getUsername();
    let userID = this.invoiceService.getUserId();

    const userData = {
      companyCode: this.invoiceDetails.company_code,
      purchaseOrg: this.invoiceDetails.purchase_org,
      docType: this.invoiceDetails.doc_type,
      emailAddress: this.invoiceDetails.email_address,
      poNo: "",
      username: username,
      userId: userID,
      items: [{ poNo: "", itemNo: "", grn: "" }],
      termsAgreed: true,
    };

    if (this.isInvoiceChange === true) {
      this.invoiceFile = this.extractedInvoiceNonPo.value.fileSource;
    } else {
      this.invoiceFile = this.invoiceService.getFileElement();
    }

    const trimNo = this.invoiceDetails.invoice_number.replace(/\s+/g, "");

    const mapKeys = {
      file_link: this.invoiceDetails.file_link,
      SellerGstin: this.invoiceDetails.gstin,
      BuyerGstin: "",
      DocNo: trimNo,
      DocTyp: "INV",
      DocDt: this.invoiceDetails.invoice_date,
      TotInvVal: this.invoiceDetails.invoice_amount,
      ItemCnt: "",
      MainHsnCode: "",
      Irn: this.invoiceDetails.irn,
      IrnDt: "",
      invType: this.invoiceService.getInvType(),
      invoiceType: this.invoiceService.getInvoiceType(),
    };

    const fileOrder = [];
    this.supportingDocuments.forEach((file, index) => {
      const obj = {};
      obj[(index + 1).toString()] = file.name;
      fileOrder.push(obj);
    });

    // Get current user session data
    const currentUser = this.authService.getCurrentUser();

    const session = currentUser.eippSessionData.data.session;

    // Create ledger structure similar to digital invoice
    const timestamp = Date.now();
    const ledger = [
      {
        docDate: this.dateUtils.formatDateString(this.invoiceDetails.invoice_date),
        dueDate: this.dateUtils.formatDateString(this.invoiceDetails.invoice_date),
        dueAmt: parseFloat(this.invoiceDetails.invoice_amount),
        docAmt: parseFloat(this.invoiceDetails.invoice_amount),
        docType: "APINV",
        poNo: "",
        docNo: trimNo,
        timestamp: timestamp,
        currCode: "INR",
        status: "PENDING_SUBMISSION",
        docDetail: {
          docAmt: this.invoiceDetails.invoice_amount,
          docFormat: "e-invoice",
          docCat: "non_po_based",
          docGstin: this.invoiceDetails.gstin,
          irn: this.invoiceDetails.irn,
          barcodePrefix: this.invoiceDetails.barcodePrefix,
        },
        docRef: [
          {
            src: this.invoiceDetails.file_link || "",
          },
        ],
        lineItemDetail: [
          // {
          //   poLineNo: "",
          //   grn: "",
          //   grnNo: trimNo,
          // },
        ],
        supplierCode: localStorage.getItem("vendorCode"),
        cmpCode: this.invoiceDetails.cmpCode || this.invoiceDetails.company_code,
        purchaseOrg: this.invoiceDetails.purchaseOrg || this.invoiceDetails.purchase_org,
        erpDocType: this.invoiceDetails.erpDocType || this.invoiceDetails.doc_type,
        email: this.invoiceDetails.email_address,
      },
    ];

    const formData: any = new FormData();
    formData.append("sellerCode", this.authService.getSellerCode());
    formData.append("reqType", "payexap");
    formData.append("session", JSON.stringify(session));
    formData.append("action", "add");
    formData.append("supplierNm", localStorage.getItem("displayName"));
    formData.append("ledger", JSON.stringify(ledger));

    if (this.supportingDocuments.length !== 0) {
      for (let i = 0; i < this.supportingDocuments.length; i++) {
        formData.append("supportingDocs", this.supportingDocuments[i]);
      }
    } else {
      formData.append("supportingDocs", this.supportingDocuments);
    }

    if (!this.saving) {
      this.invoiceService.uploadInvoiceWithoutExtration(formData).subscribe(
        (res) => {
          this.responseData = res;
          if (this.responseData.status === "error") {
            this.loading = false;
            this.uploadInvoice = false;
            this.hasError = true;
            this.formSubmitted = false;
          } else {
            this.barcodeNo = this.responseData.barcode;

            this.uploadSuccessful = true;
            this.uploadInvoice = false;
          }
        },
        (error) => {
          console.error(error);
          this.loading = false;
          this.error = error.error.message;
          this.uploadInvoice = false;
          this.uploadSuccessful = false;
          this.invoiceSaved = false;
          this.serverError = true;
        }
      );
    }

    this.modalService.dismissAll(); 
  }

  showDate() {
  }
  fetchPurchaseOrg() {
    const configReq = {
      type: "purchaseOrganizations",
    };

    this.invoiceService.getConfig(configReq).subscribe(
      (res) => {
        this.configResOrg = res;
        if (this.configResOrg.length !== 0 && this.configResOrg.status === "error") {
            console.error(this.configResOrg + " Error");
        } else {
          this.organisations = this.configResOrg.data;
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  fetchCompanyCode() {
    const configReq = {
      type: "companyCodes",
    };

    this.invoiceService.getConfig(configReq).subscribe(
      (res) => {
        this.configResCompanies = res;
        if (this.configResCompanies.length !== 0 && this.configResCompanies.status === "error") {
          console.error(this.configResCompanies + " Error");
        } else {
          this.companies = this.configResCompanies.data;
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  ngOnInit(): void {
    this.displayName = localStorage.getItem("displayName");
    this.invoiceDetails = this.invoiceService.getProcessedInvoice();

    this.formSubmitted = false;

    this.fetchCompanyCode();
    this.fetchPurchaseOrg();

    this.extractedInvoiceNonPo.patchValue({
      purchaseOrg: this.invoiceDetails.purchaseOrg,
      docType: this.invoiceDetails.erpDocType,
      emailAddress: this.invoiceDetails.email_address.toLowerCase(),
      companyCode: parseInt(this.invoiceDetails.cmpCode),
      username: this.invoiceService.getUsername(),
      userID: this.invoiceService.getUserId(),
    });
    this.loadFile();

  }

  closeSuccessDialog() {
    this.loading = false;
    this.router.navigateByUrl("/invoices");
  }

  closeErrorDialog() {
    this.loading = false;
    this.savingError = false;
    this.serverError = false;
  }

  resubmitInvoice() {
    this.router.navigateByUrl("/submit-nonpo-invoice");
  }

  onCheckboxChange(e: any) {
    if (e.target.checked) {
      this.extractedInvoiceNonPo.patchValue({
        terms_agreed: e.target.value,
      });
    } else {
      this.extractedInvoiceNonPo.patchValue({
        terms_agreed: null,
      });
    }
  }

  loadFile() {
    if (typeof FileReader !== "undefined") {
      let reader = new FileReader();
      reader.onload = (e: any) => {
        this.pdfSrc = e.target.result;
      };
      let $file: any = this.invoiceService.getFileElement();
      reader.readAsArrayBuffer($file);
    }
  }

  viewSavedInvoices() {
    this.router.navigate(["/saved-invoices"]);
  }
}
